<template>
    <div class="modal">
        <div class="inner">
            <h2>Add To Dealer Cart</h2>
            <div class="content medium-contentz center">
                <div v-html="message"></div>
                <div v-if="loading" class="modal-icon"><font-awesome-icon icon="fa-spinner" class="icon fa-spin" /></div>
                <div v-if="errorStatus" class="modal-icon"><font-awesome-icon :icon="showIcon()" class="icon" /></div>
                <div v-else>
                    <div class="image-wrapper">
                        <img :src="product.image_src" style="max-height: 5em;"/>
                    </div>
                    <div class="product-info">
                        <p>{{ product.short_description }}</p>
                        <table class="list left">
                            <tr>
                                <td><label>UPC</label></td>
                                <td>{{ product.upc }}</td>
                            </tr>
                            <tr>
                                <td><label>Item Number</label></td>
                                <td>{{ product.item_number || 'Not Carried' }}</td>
                            </tr>
                            <tr>
                                <td><label>Available</label></td>
                                <td>{{ product.on_hand }}</td>
                            </tr>
                        </table>
                        <div style="border-top: 1px solid #ccc; margin-top: 0.25em; padding-top: 0.25em;">
                            <p v-if="cartItems.includes(product_id)">Item is in cart for <b>{{ dealer.company_name }}</b>.</p>
                            <p v-else class="note">Cart for <b>{{ dealer.company_name }}</b> has {{ cartItems.length }} item{{ cartItems.length > 1 ? 's' : '' }}.</p>
                        </div>

                    </div>
                </div>
            </div>
            <div class="controls">
                <div v-if="cartItems.includes(product_id) || errorStatus == 'error'" :class="['button', 'nav-button', 'spaced', section]" @click="manageCart()">Manage Cart</div>
                <div v-else :class="['button', 'nav-button', 'spaced', errorStatus ? 'disabled' : section ]" @click="addToCart()">Add To Cart</div>
                <div class="button nav-button spaced cancel" @click="dismissMessage()">Cancel</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'adding-to-cart',
    props: {
        section: {
            type: String,
            default: ''
        },
        product_id: {
            type: [String, Number],
            default: ''
        },
        dealer: {
            type: Object,
            default: () => {}
        }
    },
	data() {
		return {
            message: '',
            loading: false,
            product: {},
            cartItems: [],
            errorStatus: false,
			messageTimeout: null
		}
	},
    created() {
        this.getProductInfo()
    },
	methods: {
        getProductInfo() {
            if (this.loading) return
            this.errorStatus = ''
            this.loading = true
            this.message = 'Getting product availability...'
            this.apiCall({ destination: 'get_product_availability', data: { source: 'dlink', distributor_id: this.getApiUser.distributor_id, product_id: this.product_id, location_id: this.dealer.location_id } }).then(obj => {
                this.loading = false
                if (obj.status == 'success') {
                    this.message = ''
                    this.product = obj.product
                    if (obj.cart_items) {
                        this.cartItems = obj.cart_items
                    }
                } else {
                    this.errorStatus = obj.status
                    this.message = obj.message
                }
            }).catch(err => {
                console.log(err)
            })
        },
        addToCart() {
            if (this.loading || this.cartItems.includes(this.product.product_id)) return
            this.loading = true
            this.errorStatus = ''
            this.message = 'Adding to dealer cart...'
            this.apiCall({ destination: 'add_to_dealer_cart', data: { source: 'dlink', product_id: this.product_id, location_id: this.dealer.location_id } }).then(obj => {
                this.loading = false
                this.errorStatus = obj.status
                if (obj.status == 'success') {
                    this.message = 'Item added to cart!'
                    this.$emit('added', this.product_id)
                    this.setMessageTimeout()
                } else {
                    this.message = obj.message
                }
            }).catch(err => {
                console.log(err)
            })
        },
        manageCart() {
            this.$router.push({ name: 'dlink-carts', params: { location_id: this.dealer.location_id } })
        },
        setMessageTimeout() {
            this.messageTimeout = setTimeout(() => { this.dismissMessage() }, 2000)
        },
        dismissMessage() {
            clearTimeout(this.messageTimeout)
            this.$emit('dismiss')
        },
        showIcon() {
            switch (this.errorStatus) {
                case 'invalid':
                    return 'fa fa-ban'
                case 'waiting':
                    return 'fa fa-hourglass'
                case 'alert':
                    return 'fa fa-bell'
                case 'error':
                    return 'fa fa-bug';
                case 'delete':
                    return 'fa fa-trash'
                default:
                    return 'fa fa-check'
            }
        }
    }
}
</script>
